import React, { useEffect, useState } from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Sidebar from "../../pages/SideBar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  listCustomerInteractionsVendor,
  listCustomerViewService,
} from "../../components/Header/Data3";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { FadeLoader } from "react-spinners";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CustomerInitiated = () => {
  const [customers, setCustomers] = useState([]);
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [customerInteractions, setCustomerInteractions] = useState(false);
  const [viewType, setViewType] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCustomer = async () => {
      const Id = user?.UserID;
      const response = await listCustomerInteractionsVendor(Id);
      console.log(response, "response");
      setCustomers(response);
    };

    const fetchListCustomerView = async () => {
      const userId = user?.UserID;
      const response = await listCustomerViewService(userId);
      console.log(response, "viewList");

      setViewList(response);
    };
    setLoading(true);
    fetchCustomer();
    fetchListCustomerView();
    setLoading(false);
  }, []);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));
  // Group by service name and count
  const serviceCount = customers.reduce((acc, item) => {
    if (!acc[item.list_name]) {
      acc[item.list_name] = 1;
    } else {
      acc[item.list_name]++;
    }
    return acc;
  }, {});

  const serviceList = Object.entries(serviceCount);
  console.log(serviceList, "serviceList");
  const listTypeData = viewType === "Customers" ? customers : viewList;
  return (
    <section className="home-after-login bg-white position-relative">
      <div className="container ">
        <Row className="">
          <Col sm={3}>
            <Sidebar />
          </Col>
          <Col sm={9}>
            {loading ? (
              <FadeLoader // FadeLoader component
                color={"#36D7B7"}
                loading={loading}
                style={{ top: "30%" }}
                className="position-absolute translate-middle start-50"
              />
            ) : (
              <>
                <h3 className="text-center my-3">Customers Initiated</h3>
                <TableContainer
                  component={Paper}
                  sx={{
                    overflowX: "scroll",
                    overflowY: "scroll",
                    height: "1110px",
                  }}
                >
                  <Table
                    sx={{ overflowX: "scroll" }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">
                          List Name
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Calls Initiated
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Messages sent
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Listings Viewed
                        </StyledTableCell>
                        {/* <StyledTableCell align="center">
                          Initiated On
                        </StyledTableCell> */}
                        {/* <StyledTableCell align="center">
                          User Name
                        </StyledTableCell> */}
                      </TableRow>
                    </TableHead>
                    {serviceList.length !== 0 ? (
                      <TableBody className="text-center">
                        {serviceList.map((customer, i) => (
                          <StyledTableRow
                            key={i}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                            className="text-center"
                          >
                            <StyledTableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {customer[0]}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <b
                                onClick={() => {
                                  setCustomerInteractions(true);
                                  setViewType("Customers");
                                }}
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                {customer[1]}
                              </b>
                            </StyledTableCell>
                            <StyledTableCell align="center"></StyledTableCell>
                            <StyledTableCell align="center">
                              <b
                                onClick={() => {
                                  setCustomerInteractions(true);
                                  setViewType("View List");
                                }}
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "blue",
                                }}
                              >
                                {viewList.length}
                              </b>
                            </StyledTableCell>
                            {/* <StyledTableCell align="center">
                              {moment(
                                customer.interaction_date.split("T")[0]
                              ).format("MMMM DD, YYYY")}
                              {moment(
                                customer.interaction_date.split("T")[1],
                                "HH:mm:ss"
                              ).format(" [at] h:mm A")}
                            </StyledTableCell> */}
                            {/* <StyledTableCell align="center">
                              {`${customer?.first_name} ${customer?.last_name}`}
                            </StyledTableCell> */}
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody className="">
                        <StyledTableRow colSpan={5}>
                          <StyledTableCell
                            colSpan={5}
                            align="center"
                            style={{ fontSize: "larger" }}
                          >
                            No Calls Initiated
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </>
            )}
          </Col>
        </Row>
        <Modal
          isOpen={customerInteractions}
          toggle={() => setCustomerInteractions(false)}
          size="lg"
        >
          <ModalBody>
            {" "}
            {loading ? (
              <FadeLoader // FadeLoader component
                color={"#36D7B7"}
                loading={loading}
                style={{ top: "30%" }}
                className="position-absolute translate-middle start-50"
              />
            ) : (
              <>
                <h3 className="text-center my-3">
                  {viewType === "Customers"
                    ? "Calls Initiated"
                    : "Listings Viewed"}
                </h3>
                <TableContainer
                  component={Paper}
                  sx={{
                    overflowX: "scroll",
                    overflowY: "scroll",
                  }}
                >
                  <Table
                    sx={{ overflowX: "scroll" }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Initiated On</StyledTableCell>
                        <StyledTableCell>User Name</StyledTableCell>
                        <StyledTableCell>Profile Link</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    {listTypeData.length !== 0 ? (
                      <TableBody className="">
                        {listTypeData.map((list, i) => (
                          <StyledTableRow
                            key={i}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <StyledTableCell>
                              {moment(
                                list.interaction_date.split("T")[0]
                              ).format("MMMM DD, YYYY")}
                              {moment(
                                list.interaction_date.split("T")[1],
                                "HH:mm:ss"
                              ).format(" [at] h:mm A")}
                            </StyledTableCell>
                            <StyledTableCell>
                              {`${list?.first_name} ${list?.last_name}`}
                            </StyledTableCell>
                            <StyledTableCell>
                              <div
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "#007bff",
                                  fontWeight: "bold",
                                }}
                                onClick={() =>
                                  navigate(`/userDetails/${list?.customer_id}`)
                                }
                              >
                                Click here
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody className="">
                        <StyledTableRow colSpan={5}>
                          <StyledTableCell
                            colSpan={5}
                            align="center"
                            style={{ fontSize: "larger" }}
                          >
                            No Calls Initiated
                          </StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </>
            )}
          </ModalBody>
        </Modal>
      </div>
    </section>
  );
};

export default CustomerInitiated;
